/* eslint-disable max-len */
import React from 'react';

const IconZoomIn = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55">
        <path className="border" d="M27.5,1A26.5,26.5,0,1,1,1,27.5,26.53,26.53,0,0,1,27.5,1m0-1A27.5,27.5,0,1,0,55,27.5,27.50005,27.50005,0,0,0,27.5,0Z"/><path d="M37.49976,26.6H28.40015V17.50037a.90039.90039,0,0,0-1.80078,0V26.6H17.49976a.90039.90039,0,0,0,0,1.80078h9.09961v9.09961a.90039.90039,0,0,0,1.80078,0V28.40076h9.09961a.90039.90039,0,1,0,0-1.80078Z"/></svg>
);

export default IconZoomIn;
